import { render, staticRenderFns } from "./uploadPic.vue?vue&type=template&id=7283922e&scoped=true&"
import script from "./uploadPic.vue?vue&type=script&lang=js&"
export * from "./uploadPic.vue?vue&type=script&lang=js&"
import style0 from "./uploadPic.vue?vue&type=style&index=0&id=7283922e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7283922e",
  null
  
)

export default component.exports